import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App'
import { installGlobalErrorReporting } from './lib/clientLog'
import { ErrorBoundary } from './lib/ErrorBoundary'

// Catch uncaught script errors and unhandled promise rejections at the
// window level so anything missed by the `request` helper still lands in
// the server log. Must run before any render so we capture mount-time errors.
installGlobalErrorReporting()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root element missing')

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary boundary="root">
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
